export default {
    container: {
        width: 1200,
        margin: "0 auto",
        maxWidth: "90%",
        display: "flex"
    }
};
